<template>
  <div>
    <div class="columns is-desktop">
      <div class="column">
        <p class="text-justify font-weight-bold">Updated less than 14 minutes ago</p>

        <h1 class="font-weight-bold">Africa</h1>

        <mdb-row>
          <mdb-col>
            <h5>RECOVERED</h5>
          </mdb-col>
          <mdb-col>
            <mdb-progress :height="30" :value="recoveryRate" id="continentRCVR">{{recoveryRate}}%</mdb-progress>
            <mdb-progress
              :height="30"
              :value="recoveryrate"
              class="hideStateRCVR"
              id="stateRCVR"
            >{{recoveryrate}}%</mdb-progress>
          </mdb-col>
        </mdb-row>

        <mdb-row class="mt-3">
          <mdb-col>
            <mdb-btn color="dark-green" size="md" class="custom-btn" @click.native="modal = true">
              <mdb-icon icon="bell" class="mr-1" />Notify me
            </mdb-btn>

            <social-sharing
              url="http://192.168.43.238:8080/"
              title="Infodemics COVID-19 Update"
              description="Infodemics COVID-19 Update"
              quote="Infodemics is a website that gives realtime updates on covid19 pandemic"
              hashtags="novelcovid,coronavirus,covid19"
              twitter-user="infodemic"
              inline-template
            >
              <mdb-popover trigger="click" :options="{placement: 'top'}">
                <span slot="header">Share</span>
                <span slot="body">
                  <network network="facebook">
                    <mdb-btn class="btn-fb" icon="facebook-f" fab size="sm">Facebook</mdb-btn>
                  </network>
                  <network network="linkedin">
                    <mdb-btn class="btn-li" icon="linkedin-in" fab size="sm">Linkedin</mdb-btn>
                  </network>
                  <network network="twitter">
                    <mdb-btn class="btn-tw" icon="twitter" fab size="sm">Twitter</mdb-btn>
                  </network>
                  <network network="whatsapp">
                    <mdb-btn class="btn-comm" icon="comments" fab size="sm">WhatsApp</mdb-btn>
                  </network>
                </span>

                <mdb-btn color="dark-green" slot="reference" size="md" class="custom-btn">Share</mdb-btn>
              </mdb-popover>
            </social-sharing>
          </mdb-col>
        </mdb-row>

        <!-- Modal (Notify me) -->

        <mdb-modal :show="modal" @close="modal = false">
          <mdb-modal-header>
            <mdb-modal-title>Notify me</mdb-modal-title>
          </mdb-modal-header>
          <mdb-modal-body>
            <mdb-input label="Email" type="email" class="mb-5" />
            <select class="browser-default custom-select">
              <option selected>Country</option>
              <option value="1">Nigeria</option>
              <option value="2">Algeria</option>
              <option value="3">Ghana</option>
            </select>
            <mdb-input label="When" type="text" />
          </mdb-modal-body>
          <mdb-modal-footer>
            <mdb-btn color="secondary" @click.native="modal = false">Close</mdb-btn>
            <mdb-btn color="primary">Submit</mdb-btn>
          </mdb-modal-footer>
        </mdb-modal>

        <!-- End -->
        <div class="columns is-desktop">
          <!-- Africa Stats -->
          <!-- <div class="column" v-if="hideContinentStat"> -->
          <div class="column" id="continents">
            <div class="columns is-mobile">
              <div class="column mt-5">
                <mdb-card class="custom-card" style="background: #FB695D">
                  <mdb-card-body class="text-center">
                    <mdb-card-title>
                      <!-- <strong>{{affectedcounts}}</strong> -->
                      <strong>{{affected}}</strong>
                    </mdb-card-title>
                    <mdb-card-text class="custom-text">Affected Countries</mdb-card-text>
                  </mdb-card-body>
                </mdb-card>
              </div>
              <div class="column mt-5">
                <mdb-card class="custom-card" style="background: #F65164">
                  <mdb-card-body class="text-center">
                    <mdb-card-title>
                      <!-- <strong>{{stats.deceased}}</strong> -->
                      <strong>{{statistics.deceased}}</strong>
                    </mdb-card-title>
                    <mdb-card-text class="custom-text">Total Deceased</mdb-card-text>
                  </mdb-card-body>
                </mdb-card>
              </div>
            </div>
            <div class="columns is-mobile">
              <div class="column mt-2">
                <mdb-card class="custom-card" style="background: #65DD9B">
                  <mdb-card-body class="text-center">
                    <mdb-card-title>
                      <!-- <strong>{{stats.confirmed}}</strong> -->
                      <strong>{{statistics.confirmed}}</strong>
                    </mdb-card-title>
                    <mdb-card-text class="custom-text">Confirmed Cases</mdb-card-text>
                  </mdb-card-body>
                </mdb-card>
              </div>
              <div class="column mt-2">
                <mdb-card class="custom-card" style="background: #2296F3">
                  <mdb-card-body class="text-center">
                    <mdb-card-title>
                      <!-- <strong>{{stats.recovered}}</strong> -->
                      <strong>{{statistics.recovered}}</strong>
                    </mdb-card-title>
                    <mdb-card-text class="custom-text">Total Recovered</mdb-card-text>
                  </mdb-card-body>
                </mdb-card>
              </div>
            </div>
          </div>
          <!-- End Africa Stats -->

          <!-- Nigeria Stats -->
          <!-- <div class="column" v-else> -->
          <div class="column hideCountry" id="country">
            <div class="columns is-mobile">
              <div class="column mt-5">
                <mdb-card class="custom-card" style="background: #FB695D">
                  <mdb-card-body class="text-center">
                    <mdb-card-title>
                      <strong>{{affectedcounts}}</strong>
                      <!-- <strong>{{affected}}</strong> -->
                    </mdb-card-title>
                    <mdb-card-text class="custom-text">Affected States</mdb-card-text>
                  </mdb-card-body>
                </mdb-card>
              </div>
              <div class="column mt-5">
                <mdb-card class="custom-card" style="background: #F65164">
                  <mdb-card-body class="text-center">
                    <mdb-card-title>
                      <strong>{{stats.deceased}}</strong>
                      <!-- <strong>{{statistics.deceased}}</strong> -->
                    </mdb-card-title>
                    <mdb-card-text class="custom-text">Total Deceased</mdb-card-text>
                  </mdb-card-body>
                </mdb-card>
              </div>
            </div>
            <div class="columns is-mobile">
              <div class="column mt-2">
                <mdb-card class="custom-card" style="background: #65DD9B">
                  <mdb-card-body class="text-center">
                    <mdb-card-title>
                      <strong>{{stats.confirmed}}</strong>
                      <!-- <strong>{{statistics.confirmed}}</strong> -->
                    </mdb-card-title>
                    <mdb-card-text class="custom-text">Confirmed Cases</mdb-card-text>
                  </mdb-card-body>
                </mdb-card>
              </div>
              <div class="column mt-2">
                <mdb-card class="custom-card" style="background: #2296F3">
                  <mdb-card-body class="text-center">
                    <mdb-card-title>
                      <strong>{{stats.recovered}}</strong>
                      <!-- <strong>{{statistics.recovered}}</strong> -->
                    </mdb-card-title>
                    <mdb-card-text class="custom-text">Total Recovered</mdb-card-text>
                  </mdb-card-body>
                </mdb-card>
              </div>
            </div>
          </div>
          <!-- End Nigeria STats -->

          <div class="column mt-5">
            <img src="../../assets/map.png" />
          </div>
        </div>

        <div class="mt-5">
          <div class="columns is-mobile">
            <div class="column">
              <div class="custom-row">
                <div class="figure square" style="background: #FF1500;"></div>
                <div style="flex: 1;" class="ml-3">1000 - 5000</div>
              </div>
              <div class="custom-row mt-3">
                <div class="figure square" style="background: #DE3324;"></div>
                <div style="flex: 1;" class="ml-3">500 - 999</div>
              </div>
              <div class="custom-row mt-3">
                <div class="figure square" style="background: #FB6255;"></div>
                <div style="flex: 1;" class="ml-3">100 - 499</div>
              </div>
              <div class="custom-row mt-3">
                <div class="figure square" style="background: #F7C1BE;"></div>
                <div style="flex: 1;" class="ml-3">1 - 9</div>
              </div>
              <div class="custom-row mt-3">
                <div class="figure square" style="background: #2296F3;"></div>
                <div style="flex: 1;" class="ml-3">0</div>
              </div>
            </div>
            <div class="column">
              <mdb-line-chart
                :data="lineChartData"
                :options="lineChartOptions"
                :width="500"
                :height="300"
              ></mdb-line-chart>
            </div>
          </div>
        </div>
        <br />
      </div>

      <div class="column">
        <div class="columns is-mobile">
          <div class="column">
            <p class="text-justify font-weight-bold mt-3">{{labelText}}</p>
          </div>
          <div class="column">
            <!-- <mdb-btn color="primary" @click="refresh">Back</mdb-btn> -->
          </div>
        </div>

        <b-table
          :data="tabuData"
          :columns="columns"
          :paginated="isPaginated"
          :per-page="perPage"
          :current-page.sync="currentPage"
          :pagination-simple="isPaginationSimple"
          :pagination-position="paginationPosition"
          aria-next-label="Next page"
          aria-previous-label="Previous page"
          aria-page-label="Page"
          aria-current-label="Current page"
          :selected.sync="selected"
          :mobile-cards="false"
          @click="getSelected"
        ></b-table>

        <br />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Table",
  props: [
    "tableData",
    "statistics",
    "affected",
    "recoveryRate",
    "label",
    "hideContinentStat"
  ],
  data() {
    return {
      modal: false,
      selected: {},
      tabuData: this.$props.tableData.rows,
      // stats: this.$props.statistics,
      stats: "",
      // recoveryrate: this.$props.recoveryRate,
      recoveryrate: "",
      // affectedcounts: this.$props.affected,
      affectedcounts: "",
      // tabuData: [],
      isPaginated: true,
      isPaginationSimple: false,
      paginationPosition: "bottom",
      currentPage: 1,
      perPage: 10,
      // hideContinentStat: false,
      // hideRecovryRate: false,
      labelText: this.$props.label,
      columns: [
        {
          field: "id",
          label: "ID",
          width: "40",
          numeric: true
        },
        {
          field: "name",
          label: "Location",
          searchable: true
        },
        {
          field: "confirmed",
          label: "Confirmed"
        },
        {
          field: "recovered",
          label: "Recovered"
        },
        {
          field: "serious",
          label: "Serious"
        },
        {
          field: "deceased",
          label: "Deceased"
        }
      ],
      basicOptions: [
        { text: "Option nr 1", value: "Option 1" },
        { text: "Option nr 2", value: "Option 2" },
        { text: "Option nr 3", value: "Option 3" }
      ],
      lineChartData: {
        labels: [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July"
        ],
        datasets: [
          {
            label: "My First dataset",
            backgroundColor: "rgba(255, 99, 132, 0.1)",
            borderColor: "rgba(255, 99, 132, 1)",
            borderWidth: 0.7,
            data: [65, 59, 80, 81, 56, 55, 40]
          }
        ]
      },
      lineChartOptions: {
        responsive: false,
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              gridLines: {
                display: true,
                color: "rgba(0, 0, 0, 0.1)"
              }
            }
          ],
          yAxes: [
            {
              gridLines: {
                display: true,
                color: "rgba(0, 0, 0, 0.1)"
              }
            }
          ]
        }
      }
    };
  },
  methods: {
    getSelected() {
      const selected = this.selected;
      const app = this;
      if (selected.name == " Nigeria ") {
        axios
          .get("https://coronadatasource.herokuapp.com/api/ncdc")
          .then(json => {
            axios
              .get("https://coronadatasource.herokuapp.com/api/ncdcpresent")
              .then(resp => {
                const ncdcData = json.data.data;
                const summary = resp.data.data;
                const newTabuData = ncdcData.map(item => {
                  return {
                    name: item[0],
                    confirmed: item[1]
                  };
                });

                let element = document.getElementById("continents");
                element.classList.add("hide");

                let element2 = document.getElementById("country");
                element2.classList.remove("hideCountry");

                let element3 = document.getElementById("continentRCVR");
                element3.classList.add("hideCountryRCVR");

                let element4 = document.getElementById("stateRCVR");
                element4.classList.remove("hideStateRCVR");

                app.labelText = "Nigeria COVID-19 Stats";
                app.tabuData = newTabuData;
                // let filteredData = summary.splice(1);
                app.affectedcounts = ncdcData.length - 1;

                const newObject = {};
                delete Object.assign(newObject, summary, {
                  ["deceased"]: summary["deaths"]
                })["deaths"];
                app.stats = newObject;

                let confirmed = summary.confirmed;
                let recovered = summary.recovered;

                let recoveredRate = (recovered / confirmed) * 100;
                app.recoveryrate = Math.ceil(recoveredRate);

                // console.log(app.stats);
              })
              .catch(error => {
                console.log(error);
              });
          })
          .catch(err => {
            console.log(err);
          });
      }
    }
  },
  mounted() {
    // this.getSelected();
    // var hide = document.getElementById("hideDisplay");
    // var cl = hide.classList.add("test");
    // console.log(cl);
    // console.log(document.getElementById("hideDisplay"));
  }
};
</script>

<style scoped>
.hide {
  display: none;
}
.hideCountry {
  display: none;
}
.hideStateRCVR {
  display: none;
}
.hideCountryRCVR {
  display: none;
}
.custom-btn {
  text-transform: none !important;
  background-color: #65dd9b !important;
  color: #14264d;
}
.custom-card {
  border-radius: 5%;
  color: #fff;
  /* width: 50%; */
}
.custom-text {
  color: #fff !important;
}
.figure {
  border-color: rgba(60, 124, 251, 0.3);
}
.square {
  width: 25px;
  height: 25px;
}
.custom-row {
  display: flex;
  flex-direction: row;
}
</style>